angular.module('unergie.main')
.controller('processComplaintModalCtrl', ($scope, $uibModalInstance, complaint, ApiAdmin, JiraService, FileUploader, ErrorCatcher, AlertManager, BoFeaturesService) => {
    $scope.chosen = {}
    $scope.isComplaintsFeatureOn = (feature) => BoFeaturesService.getModuleFeatures('complaints')[feature]
    $scope.fetchComplaint = () => {
        $scope.loadingComplaint = true
        return ApiAdmin.getJiraStatusHistoryAndPublicComments({ idIssue: complaint.key }).$promise
        .then((jiraResponse) => {
            $scope.complaint = jiraResponse.fields
            $scope.complaint.key = complaint.key
            $scope.complaint.lastComment = jiraResponse.publicComments[jiraResponse.publicComments.length - 1]
                && JiraService.attachmentCommentCleaner(jiraResponse.publicComments[jiraResponse.publicComments.length - 1].body)
            $scope.loadingComplaint = false

            $scope.actions = [
                { label: 'Sauvegarder' },
                {
                    label: 'Résoudre',
                    transitionId: $scope.isComplaintsFeatureOn('canSolveComplaint') ? null : 171,
                    displaySolveActions: $scope.isComplaintsFeatureOn('canSolveComplaint'),
                },
                { label: 'Envoyer IT', transitionId: 131 },
                { label: 'Envoyer partenaire', transitionId: 121 },
                {
                    label: 'Envoyer Enedis',
                    transitionId: 111,
                    displayEnedisFields: true,
                },
            ]
            $scope.chosen.action = $scope.actions[0]

            $scope.solveActions = [
                { label: 'Clore - Accepter', transitionId: $scope.complaint.complaintLevel === 'N2' ? 181 : 201 },
                { label: 'Clore - Refuser', transitionId: $scope.complaint.complaintLevel === 'N2' ? 331 : 241 },
                { label: 'À rembourser', transitionId: $scope.complaint.complaintLevel === 'N2' ? 361 : 291 },
            ]
            $scope.chosen.solveAction = $scope.solveActions[0]
        })
        .catch(ErrorCatcher)
    }
    $scope.fetchComplaint()

    $scope.publicAttachmentUploader = new FileUploader({
        method: 'POST',
        autoUpload: false,
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onCompleteAll() {
            AlertManager.success('Pièces jointes publiques enregistrées.')
            $scope.close()
            $scope.saving = false
        },
    })

    $scope.privateAttachmentUploader = new FileUploader({
        method: 'POST',
        autoUpload: false,
        onErrorItem(item, response, status, headers) {
            return ErrorCatcher(response)
        },
        onCompleteAll() {
            AlertManager.success('Pièces jointes enregistrées.')
            $scope.close()
            $scope.saving = false
        },
    })

    $scope.confirmComplaintSubmit = () => {
        $scope.saving = true
        return ApiAdmin.postIssueComment({ idIssue: complaint.key, issueType: 'complaint' }, { comment: $scope.complaint.transitionComment, isPublic: true }).$promise
        .then(() => {
            if ($scope.chosen.action.transitionId || ($scope.chosen.action.displaySolveActions && $scope.chosen.solveAction.transitionId)) {
                return ApiAdmin.performIssueTransition({ idIssue: complaint.key, issueType: 'complaint' },
                    {
                        id: ($scope.chosen.action.transitionId || ($scope.chosen.action.displaySolveActions && $scope.chosen.solveAction.transitionId)).toString(),
                        comment: $scope.transitionComment,
                    }).$promise
            }
        })
        .then(() => {
            if ($scope.publicAttachmentUploader.queue.length > 0) {
                AlertManager.success('Réclamation traitée, tranfert des pièces jointes publiques...')
                $scope.publicAttachmentUploader.queue.forEach((file) => {
                    file.url = `/api-admin/jira/servicedesk/project/complaints/issue/${complaint.key}/add/file`
                    file.formData = [{ isPublic: true }]
                })
                $scope.publicAttachmentUploader.uploadAll()
            }
            if ($scope.privateAttachmentUploader.queue.length > 0) {
                AlertManager.success('Réclamation traitée, tranfert des pièces jointes internes...')
                $scope.privateAttachmentUploader.queue.forEach((file) => {
                    file.url = `/api-admin/jira/servicedesk/project/complaints/issue/${complaint.key}/add/file`
                    file.formData = [{ isPublic: false }]
                })
                $scope.privateAttachmentUploader.uploadAll()
            } else {
                AlertManager.success('Réclamation traitée.')
                $scope.close()
                $scope.saving = false
            }
        })
        .catch((err) => {
            AlertManager.error(`Une erreur est survenue lors de l'appel a JIRA ${err.data && `: ${err.data.message}`}`, 5000)
        })
    }

    $scope.canConfirmComplaintSubmit = () => {
        return $scope.complaint.transitionComment
    }

    $scope.close = () => $uibModalInstance.close()
})
